type Props = {
    url: string,
    cssStyles?: string,
    onClick?: () => void,
    glyph?: boolean,
}

export function Icon({ url, cssStyles = '', onClick, glyph = true }: Props) {
    return (<img 
        src={url} 
        alt={'Icon'} 
        className={`w-4 min-w-[1rem] inline-block ${glyph ? 'icon-glyph' : ''} ${!!onClick ? `hover:cursor-pointer` : ''} ${cssStyles}`} 
        onClick={onClick} 
        />);
}